import { render, staticRenderFns } from "./TopPrice.vue?vue&type=template&id=35d2a610&scoped=true&"
import script from "./TopPrice.vue?vue&type=script&lang=js&"
export * from "./TopPrice.vue?vue&type=script&lang=js&"
import style0 from "./TopPrice.vue?vue&type=style&index=0&id=35d2a610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d2a610",
  null
  
)

export default component.exports